const MIN_HEADER_LEVEL = 2;
const MAX_HEADER_LEVEL = 4;

const isTitleLevelValid = (titleLevel) => {
  return !titleLevel || titleLevel > MIN_HEADER_LEVEL || titleLevel < MAX_HEADER_LEVEL;
}

const TrendsTitle = ({ title, titleLevel}) => {
  if(!title || !isTitleLevelValid(titleLevel)) return null;

  const TitleTag = `h${Number(titleLevel)}`;

  return (
    <TitleTag dangerouslySetInnerHTML={{ __html: title || '' }} />
  );
}

export default TrendsTitle;